import React from "react";
import './SearchResultsDisplay.css';
import { navigateToView } from "utilities/js/NavigationHelper";
import getTimeSince from "utilities/js/TimeManager";
import { navigateToAccountPage } from "utilities/js/NavigationHelper";
import { NavigatorWrapper } from "components/reusable/NavigatorWrapper";
import Constants from "utilities/js/Constants";

const loadingIcon = Constants.ICON_LOADING;

class SearchResultsDisplay extends React.Component {

    constructor(props){
        super(props);
        

        this.formContainerRef = React.createRef();

        this.state = {
            searchTerm: '',
            searchResults: this.props.searchResults,

            displayLoginScreen: true,
            errorDisplay: ''
        };

        this.navigateToViewBracket = this.navigateToViewBracket.bind(this);
        this.navigateToAccountPage = this.navigateToAccountPage.bind(this);
    }

    /*********************** Search Logic **************************/
    
    /******************************* Input Setters  ************************************/

    /*********************** Screen flow controls ***********************/
    navigateToViewBracket(event){
        let bracketId = event.currentTarget.dataset.id;
        let bracket = this.state.searchResults.find(bracket => {
            return bracket._id = bracketId;
        })

        navigateToView({bracketId: bracket.view_id, routerNav: this.props.navigate});
    }
    navigateToAccountPage(event){
        let userId = event.currentTarget.dataset.id;
        let user = this.state.searchResults.find(user => {
            return user._id = userId;
        })

        navigateToAccountPage({
            accountId: user._id, 
            routerNav: this.props.navigate
        });
    }



    /*********************** UI Render Helpers ***********************/
    loadingScreen(){
        if(this.state.isLoading){
            return (<div className="loading-icon-container"><img src={loadingIcon} alt="loading"></img></div>)
        }
        return;
    }

    chooseSearchResultDisplay(){
        if(this.props.table === 'account'){
            return this.getSearchResultDisplay_User();
        }else if(this.props.table === 'bracket'){
            return this.getSearchResultDisplay_Bracket();
        }
    }

    getSearchResultDisplay_Bracket(){
        if(!this.state.isLoading && this.props.searchResults){
            let resultList = this.props.searchResults.map(result => {
                return (<div key={result._id} data-id={result._id} className="search-result-line-item" onClick={this.navigateToViewBracket}>
                    <div className="search-result-line-item-main">
                        <div className="search-result-line-item-header">{result.title}</div>
                        <div className="search-result-line-item-body">
                            @{result.created_by?.username ? result.created_by.username : result.created_by}
                            <div className="search-result-line-item-subtext">{getTimeSince(result.created_date)}</div>
                        </div>
                    </div>
                    {/* <div className="search-result-line-item-bonus">{result.premium}</div> */}
                </div>)
            })
        
            return (
                <>
                    <div className="search-results-container">
                        {resultList}
                    </div>
                </>
            );
        
        }
    }

    getSearchResultDisplay_User(){
        if(!this.state.isLoading && this.props.searchResults){
            let resultList = this.props.searchResults.map(result => {
                return (<div key={result._id} data-id={result._id} className="search-result-line-item"  onClick={this.navigateToAccountPage}>
                    <div className="search-result-line-item-main">
                        <div className="search-result-line-item-header">@{result.username}</div>
                        <div className="search-result-line-item-body">
                            {result.first_name} {result.last_name} 
                            {/* <div className="search-result-line-item-subtext">{result.created_date}</div> */}
                        </div>
                    </div>
                    <div className="search-result-line-item-bonus">{result.premium}</div>
                </div>)
            })
        
            return (
                <>
                    <div className="search-results-container">
                        {resultList}
                    </div>
                </>
            );
        
        }
    }

    render(){
        return (
            <>
                {this.loadingScreen()}
                {this.chooseSearchResultDisplay()}
            </>
        );
    }
}

export default NavigatorWrapper(SearchResultsDisplay);
